import React, { useEffect } from "react";
import { Button, Modal, Input, Select, Popconfirm, Form } from "antd";

export const EmployeeDlg = ({ roles, model, save, saving, visible, close, resend, resending, enabled, setting }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(model);
  }, [model, form]);

  const rules: any = {
    firstName: [{ required: true, trigger: "change" }],
    lastName: [{ required: true, trigger: "change" }],
    title: [{ required: true, trigger: "change" }],
    roles: [{ required: true, type: "array", trigger: "change" }],
    email: [{ type: "email", message: "The input is not valid E-mail", required: true }],
  };

  const onSave = () => {
    form.validateFields().then((values) => {
      save(values);
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title="Employee"
      visible={visible}
      onOk={onSave}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => close()}
    >
      {!!model.id && (
        <div style={{ textAlign: "right", marginBottom: 20 }}>
          <Button.Group>
            {model.poolInfo?.status === "FORCE_CHANGE_PASSWORD" ? (
              <Popconfirm title="Are you sure to reset this employee's password?" onConfirm={() => resend()}>
                <Button danger loading={resending}>
                  Resend Password
                </Button>
              </Popconfirm>
            ) : (
              <Button danger disabled>
                Resend Password
              </Button>
            )}

            {model.poolInfo?.enabled ? (
              <Popconfirm title="Are you sure to deactivate this account?" onConfirm={() => enabled()}>
                <Button danger loading={setting}>
                  Deactivate Account
                </Button>
              </Popconfirm>
            ) : (
              <Popconfirm title="Are you sure to activate this account?" onConfirm={() => enabled()}>
                <Button danger loading={setting}>
                  Activate Account
                </Button>
              </Popconfirm>
            )}
          </Button.Group>
        </div>
      )}
      <Form form={form} {...layout} initialValues={{ ...model }}>
        <Form.Item label="Email (Username)" name="email" rules={rules.email}>
          <Input disabled={!!model.id} placeholder="Enter employee email" />
        </Form.Item>
        <Form.Item label="Title" name="title" rules={rules.title}>
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item label="First Name" name="firstName" rules={rules.firstName}>
          <Input placeholder="Enter employee first name" />
        </Form.Item>
        <Form.Item label="Last Name" name="lastName" rules={rules.lastName}>
          <Input placeholder="Enter employee last name" />
        </Form.Item>
        <Form.Item label="Roles" name="roles" rules={rules.roles}>
          <Select mode="multiple" allowClear>
            {roles.map((r) => (
              <Select.Option value={r.name} key={r.id}>
                {r.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
